"use strict";

//#region import
import axios from "axios";
// import router from "../router";
//#endregion

//#region private
// 请求拦截
axios.interceptors.request.use(
    function (req) {
        console.log("========请求拦截start========")
        req.headers.wxtoken = localStorage.getItem("wxtoken");
        req.headers.uid = localStorage.getItem("uid");
        console.log("========请求拦截  end========")
        return req;
    },
    function (err) {
        return Promise.reject(err);
    }
);

// 响应拦截
axios.interceptors.response.use(
    function (res) {
        console.log('axios.interceptors.response res=>', res);
        return res.data;
    },
    function (err) {
        console.log(err);
        // if (err.response.status === 401 || err.response.data === 'login expired') {
        //     router.replace({
        //         path: "/"
        //     });
        //     return;
        // }
        // if (err.response) {
        //     switch (err.response.status) {
        //         case 401:
        //             router.replace({
        //                 path: "/"
        //             });
        //             break;
        //             // case 404:
        //             //   router.replace({ path: "/pages/error-404" });
        //             //   break;
        //         default:
        //             // console.log(err.response.status);
        //             router.replace({
        //                 path: "/"
        //             });
        //             break;
        //     }
        // }
        return Promise.reject(err);
    }
);
//#endregion
export default axios;